import CryptoJS from "crypto-js";
// eslint-disable-next-line no-unused-vars
import * as Masters from "../config/masterData";
// eslint-disable-next-line no-unused-vars
import { customColors } from "../config/ColorSets";
import {
  // eslint-disable-next-line no-unused-vars
  ClockCircleOutlined,
  // eslint-disable-next-line no-unused-vars
  CheckOutlined,
  // eslint-disable-next-line no-unused-vars
  QuestionOutlined,
  // eslint-disable-next-line no-unused-vars
  UndoOutlined,
  // eslint-disable-next-line no-unused-vars
  MergeCellsOutlined,
  // eslint-disable-next-line no-unused-vars
  ToolOutlined,
  // eslint-disable-next-line no-unused-vars
  StopOutlined,
} from "@ant-design/icons";

export const encryptToken = (token) => {
  try {
    const eToken = CryptoJS.AES.encrypt(
      JSON.stringify(token),
      process.env.REACT_APP_CRYPTO_SECRET
    ).toString();
    return eToken;
  } catch (error) {
    return error;
  }
};

export const decryptToken = (token) => {
  try {
    const bytes = CryptoJS.AES.decrypt(
      token,
      process.env.REACT_APP_CRYPTO_SECRET
    );
    const dToken = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return dToken;
  } catch (error) {
    return error;
  }
};

export const isValidToken = (token) => {
  try {
    const dToken = decryptToken(token);
    if (dToken.id && dToken.empCode && dToken.access_token && dToken.expiry) {
      return true;
    }
    return false;
  } catch (error) {
    return error;
  }
};

export const getDecodedToken = () => {
  try {
    const token = localStorage.getItem("cs_access_token");
    return token ? decryptToken(token) : {};
  } catch (error) {
    return error;
  }
};
